import React, { Fragment } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { uniqueId } from 'lodash'
import { Input as DefaultInput, If, Text } from 'src/Components'

import styles from './FormField.module.scss'

const propTypes = {
  // the contents of the label
  children: PropTypes.node.isRequired,

  // set your own id instead of one generated from the name
  id: PropTypes.string,

  // the input name, gets linked to the label
  name: PropTypes.string.isRequired,

  // visually hide the label text, while leaving accessible
  hideLabel: PropTypes.bool,

  className: PropTypes.string,

  // render a specific text component
  labelText: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  // render a specific input or component
  input: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
}

const DefaultLabelText = props => (
  <Text element='span' color='quiet' size='xs' {...props} />
)
const DefaultCaptionText = props => (
  <Text element='span' color='heather' size='xs' {...props} />
)

const FormField = ({
  className,
  children,
  name,
  id = uniqueId(name),
  input,
  labelText,
  hideLabel,
  captionText,
  captionMessage,
  ...restProps
}) => {
  const LabelText = labelText || DefaultLabelText
  const CaptionText = captionText || DefaultCaptionText
  const Input = input || DefaultInput

  return (
    <Fragment>
      <label className={className} htmlFor={id}>
        <LabelText
          className={classnames(styles.labelText, hideLabel && styles.hide)}
        >
          {children}
        </LabelText>
        <Input id={id} name={name} {...restProps} />
      </label>
      <If condition={captionMessage}>
        <CaptionText className={styles.captionText}>
          {captionMessage}
        </CaptionText>
      </If>
    </Fragment>
  )
}

FormField.propTypes = propTypes

export default FormField
